import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import { WHITE, MAIN_BLACK, RADICAL_RED } from '@/constants/colors';

export const Container = styled.div`
  position: relative;
  padding: 8px 7px;
  background-color: ${WHITE};
  transition: all 0.4s;
  box-shadow: 0 4px 24px 0 ${rgba(MAIN_BLACK, 0.15)};
  text-align: center;
  border-radius: 8px;

  .service-card {
    &__link {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__plan-chip {
      position: absolute;
      top: 4px;
      right: 4px;
    }

    &__arr-date-chip {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      border-radius: 4px 4px 0 0;
      font-size: 1.1rem;
    }

    &__addon-item {
      position: absolute;
      top: 5px;
      right: 5px;

      img {
        height: 24px;
      }
    }

    &__logo {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 80px;
      width: 181px;
      margin-right: 12px;

      img {
        max-width: 100%;
        max-height: 80px;
        width: auto;
      }
    }

    &__deal-price {
      display: flex;
      flex-direction: column;
      align-items: center;

      .service-card__old-cost {
        position: relative;
        line-height: 1.9rem;
        margin-bottom: -2px;

        &:before {
          content: '';
          position: absolute;
          right: -3px;
          left: -3px;
          top: 50%;
          transform: translate(0, -50%);
          height: 1px;
          background-color: ${RADICAL_RED};
        }

        strong {
          font-weight: 400;
        }
      }
    }

    &__cost {
      strong {
        font-weight: 500;
      }
    }

    &__additional-price {
      display: inline-block;

      &-icon {
        font-size: 24px;
        margin-bottom: -6px;
      }
    }

    &__main-info {
      height: 100%;
      width: calc(100% - 192px);
      display: flex;
      flex-direction: column;
      justify-content: center;

      .price__content {
        flex: 1;
      }
    }
  }
`;

export default Container;
